import type { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { PlusIcon } from '@setup/svg-icons/svg-icons';
import { CreateActionMenu, MuiButton } from '@shared/ui-kit';

import type { StubForContainersProps } from '@shared/ui/stubs/StubForContainers/types';

export const StubForContainers: FC<StubForContainersProps> = ({
  value,
  menuList,
  callback,
  sxImgBlock,
  descriptionMaxWidth,
  btnLabel,
  btnStartIcon,
  isShowBackground,
  isShowBorder,
  isDisabledBtn,
  renderButtonComponent,
  btnSize = 'medium',
}) => {
  const backgroundOverlayStyle = {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: value.backgroundImg ? `url(${value.backgroundImg})` : '',
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: 0.5,
  };

  return (
    <Box
      sx={(theme) => {
        return {
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          position: 'relative',
          borderRadius: '8px',
          backgroundColor: isShowBackground ? theme.palette.case.neutral.n0 : '',
          border: isShowBorder ? `1px solid ${theme.palette.case.neutral.n100}` : '',
        };
      }}
    >
      <Box sx={backgroundOverlayStyle} />
      {value.img && (
        <Box
          sx={{
            width: '100%',
            maxWidth: { sm: '48px', xs: '48px' },
            ...sxImgBlock,
          }}
        >
          <img src={value.img} alt={value.description} width="100%" />
        </Box>
      )}
      {value?.title && (
        <Typography
          mt={'12px'}
          sx={{ whiteSpace: 'pre-wrap' }}
          width={'100%'}
          variant={'t14m'}
          textAlign={'center'}
          color={(theme) => theme.palette.case.neutral.n900}
        >
          {value.title}
        </Typography>
      )}

      <Typography
        mt={value?.title ? '6px' : '12px'}
        sx={{ whiteSpace: 'pre-wrap' }}
        width={'100%'}
        maxWidth={`${descriptionMaxWidth ? descriptionMaxWidth : 240}px`}
        variant={'t14r'}
        textAlign={'center'}
        color={(theme) => theme.palette.case.neutral.n600}
      >
        {value.description}
      </Typography>

      {menuList ? (
        <Box mt={'12px'}>
          <CreateActionMenu
            childrenComponent={
              <MuiButton
                isStopPropagation={false}
                startIcon={btnStartIcon ? btnStartIcon : <PlusIcon />}
                label={btnLabel}
                variant={'text'}
                size={btnSize}
                isDisabled={isDisabledBtn}
              />
            }
            menuList={menuList}
            header={null}
            isMobile={false}
            isMobileVariant={false}
            anchorOriginHorizontal="center"
            anchorOriginVertical="top"
            transformOriginHorizontal="center"
            transformOriginVertical="bottom"
          />
        </Box>
      ) : callback ? (
        <Box mt={'12px'}>
          <MuiButton
            startIcon={btnStartIcon ? btnStartIcon : <PlusIcon />}
            label={btnLabel}
            variant={'text'}
            size={btnSize}
            isDisabled={isDisabledBtn}
            onClick={callback}
          />
        </Box>
      ) : (
        <></>
      )}
      {renderButtonComponent && <Box sx={{ mt: '16px' }}>{renderButtonComponent()}</Box>}
    </Box>
  );
};

export default StubForContainers;
